import {Component, OnInit} from '@angular/core';
import {WebNavigationService} from "../../../navigation.service";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'app-submenu-promotions',
  templateUrl: './promotions-submenu.component.html',
  styleUrls: ['./promotions-submenu.component.scss']
})
export class PromotionsSubmenuComponent implements OnInit {

  constructor(private navigationService: WebNavigationService, private router: Router, private activatedRoute: ActivatedRoute) {
  }

  ngOnInit() {
  }

  selectedPromotionOption(promotionOption) {
    if (promotionOption === 0) {
      this.router.navigate(['promotionsQuantum'], {relativeTo: this.activatedRoute});
    } else if (promotionOption === 1) {
      this.navigationService.selectedOption = 'saldosGanalottodo';
      this.router.navigate(['promotionsGanalottodo/saldosGanalottodo'], {relativeTo: this.activatedRoute});
    } else if (promotionOption === 2) {
      this.navigationService.selectedOption = 'promotionsGames';
      this.router.navigate(['promotionsGanalottodo/promotionsGames'], {relativeTo: this.activatedRoute});
    }
  }

  get selectedOption() {
    return this.navigationService.selectedOption;
  }

  get expanded() {
    return this.navigationService.expanded;
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/navigation/options/promotions/promotions-submenu/promotions-submenu.component.ts